import React from 'react';


export default function Promo() {

  return (
    <>
      {/* <PromoCards /> */}

      {/* <OngoingCampaigns /> */}
    </>
  )
};
